export function getQueryParam(param: string): string | null {
  const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
  return urlParams.get(param)
}

export function getRequiredQueryParam(param: string): string {
  const value = getQueryParam(param)
  if (!value) {
    throw new Error(`Required query parameter '${param}' is missing`)
  }
  return value
}